import { store } from '../redux/store';
import Axios from 'axios';
import { changeSystemStatus } from '../redux/systemDown/thunks';

export const getSearchParameters = () => {
  const paramStr = window.location.search.substring(1);
  return paramStr != null && paramStr !== ''
    ? transformToParamMap(paramStr)
    : {};
};

export const transformToParamMap = (paramStr: string) => {
  const paramMap: { [key: string]: string } = {};
  const params = paramStr.split('&');
  params.forEach((param) => {
    const [key, value] = param.split('=');
    paramMap[key] = value;
  });

  return paramMap;
};

const SYSTEM_STATUS_URL = process.env.REACT_APP_SYSTEM_STATUS_URL;

export const getSystemStatus = async () => {
  try {
    const systemStatusResponse = await Axios.get('' + SYSTEM_STATUS_URL);

    if (systemStatusResponse.status === 200) {
      const systemStatus = await systemStatusResponse.data;
      store.dispatch(
        changeSystemStatus({
          isSystemDown:
            systemStatus.isPlannedMaintenance ||
            systemStatus.isUnplannedMaintenance ||
            systemStatus.isAcknowledgedDowntime,
          restoreDate: systemStatus.estimateTimeForNormalization,
        }),
      );
    }
  } catch (e) {
    const errorData = { error: 'cannot fetch system status' };
    return Promise.reject(errorData);
  }
};

export const getFormattedDate = (date: Date) => {
  const year = date.getFullYear();

  let month = (1 + date.getMonth()).toString();
  month = month.length > 1 ? month : `0${month}`;

  let day = date.getDate().toString();
  day = day.length > 1 ? day : `0${day}`;

  return `${month}/${day}/${year}`;
};
